export default {
  name: 'Name',
  next: 'Next',
  new_attack: 'New Test',
  no: 'No',
  nodes: 'Nodes',
  none: 'None'
}
